export const SELECTOR_SHIMMER_DIMENSIONS = [ '150px', '100px', '140px', '120px', '130px', '140px' ];

export const SELECTOR_SEARCH_KEY = 'search_item';
